import React, { useState } from 'react';

//@ts-ignore
const initialState: any = {
};

export const AppContext = React.createContext(initialState);

export const AppProvider = ({ children }) => {
    const [applicationMessage, setApplicationMessage] = useState(null);
    const [applicationSearchText, setApplicationSearchText] = useState('');    


    const showSuccessMessage = (message) => {
        setApplicationMessage({type: 'success', message: message})
    };

    const showErrorMessage = (message) => {
        setApplicationMessage({type: 'error', message: message})
    };

    const showWarningMessage = (message) => {
        setApplicationMessage({type: 'warning', message: message})
    };

    const showInfoMessage = (message) => {
        setApplicationMessage({type: 'info', message: message})
    };
    
    
    //@ts-ignore
    return <AppContext.Provider value={{
        ...initialState,
        applicationMessage, 
        setApplicationMessage,
        showSuccessMessage,
        showErrorMessage,
        showWarningMessage,
        showInfoMessage,
        applicationSearchText, 
        setApplicationSearchText
    }}>
        {children}
    </AppContext.Provider>
};
